export const chatbotMutationKeys = {
  sendMessage: ['chatbot', 'sendMessage'],
};
